import React, { useEffect, useState } from "react";
import { Wrapper } from "../components/Wrapper";
import { PageTitle } from "../components/PageTitle";
import { CustomTable } from "../components/CustomTable";
import { useNavigate } from "react-router-dom";
import { Notification } from "../utils/Notification";
import { useMutation, useQuery } from "@apollo/client";
import { Preload } from "../components/Preload";
import { GET_FAST_MENU } from "../graphql/Queries/FastMenuQuery";
import { TYPE_FAST_LINK } from "../utils/Dictionaries";
import { DELETE_FAST_MENU } from "../graphql/Mutations/FastMenuMutation";

export const FastLinks = ({ url }) => {
  const [items, setItems] = useState([]);
  const navigator = useNavigate();
  const { loading, error, data } = useQuery(GET_FAST_MENU, {
    fetchPolicy: "no-cache",
  });
  const [deleteFastMenu] = useMutation(DELETE_FAST_MENU);

  const remove = (id) => {
    deleteFastMenu({
      variables: {
        id: Number(id),
      },
    })
      .then((response) => {
        setItems(response.data.deleteFastMenu);
      })
      .catch((error) => {
        Notification(error);
      });
  };

  const edit = (id) => {
    navigator(`${url}/form?id=${id}`);
  };

  useEffect(() => {
    if (data) {
      setItems(data.fastMenu);
    }
  }, [data]);

  if (!data) {
    return <Preload />;
  }

  return (
    <Wrapper>
      <PageTitle title={"Быстрые ссылки"} />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <CustomTable
                data={items}
                columns={[
                  { key: "id", label: "ID" },
                  { key: "title.ru", label: "Название" },
                  { key: "url.ru", label: "Ссылка" },
                  {
                    key: "type",
                    label: "Тип",
                    callback: (value) => {
                      const data = TYPE_FAST_LINK.find((type) => {
                        return type.id === value;
                      });
                      return data.name;
                    },
                  },
                ]}
                search={true}
                sort={true}
                pagination={{
                  limit: 10,
                }}
                actions={[
                  {
                    slug: `${url}/form`,
                    icon: "fe-plus",
                    name: "Создать",
                  },
                ]}
                onClick={(id) => edit(id)}
                onDelete={(id) => remove(id)}
              />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
